import { useSelector } from 'react-redux';
import { iRootState } from '../redux/store';

const useIsPayNowEnabled = function useIsPayNowEnabled(): boolean {
  const isCurrencyPayDisable = useSelector(
    (state: iRootState) => state.quote.isCurrencyPayDisable
  );

  const isQuoteLoaded = useSelector(
    (state: iRootState) => state.quote.paymentStatus !== 'undefined'
  );

  const hasItemToPurchase = useSelector(
    (state: iRootState) =>
      state.quote.items.filter(item => item.price > 0).length > 0
  );

  const hasValidTotal = useSelector(
    (state: iRootState) => state.quote.total > 0
  );

  const isQuotePaid = useSelector(
    (state: iRootState) =>
      !!state.quote.paymentStatus &&
      (state.quote.paymentStatus.toLocaleLowerCase() === 'paid' ||
        state.quote.paymentStatus.toLocaleLowerCase() === 'pending' ||
        state.quote.paymentStatus.toLocaleLowerCase() === 'under review')
  );

  const wasCurrencyConverted = useSelector(
    (state: iRootState) => state.quote.wasCurrencyConverted
  );

  const isCurrencyPayAllowed =
    !isCurrencyPayDisable &&
    isQuoteLoaded &&
    hasItemToPurchase &&
    hasValidTotal &&
    !isQuotePaid &&
    !wasCurrencyConverted;

  return isCurrencyPayAllowed;
};

export default useIsPayNowEnabled;
